const API = process.env.REACT_APP_API_URL;

const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

/**
 * Get all employees
 */
export const getEmployees = async (noEmplacement, token) => {
  const response = await fetch(
    `${API}/employee/GetEmployesByRestaurants/${noEmplacement}`,
    {
      method: "GET",
      headers: headers(token),
    },
  );

  return await response.json();
};

/**
 * ==========================================
 * Get Departments
 * Endpoint:
 * GET /GetDepartments
 * ==========================================
 */
export const getDepartments = async (token) => {
  const response = await fetch(`${API}/Localization/GetExternalDepartment`, {
    method: "GET",
    headers: headers(token),
  });

  if (!response.ok) {
    throw new Error("Unable to load departments.");
  }

  return await response.json();
};

/**
 * Get employee by id
 */
export const getEmployeeById = async (id, token) => {};

/**
 * Create employee
 */
/**
 * Create employee
 */
export const createEmployee = async (employee, token) => {
  const response = await fetch(`${API}/EmployeeManagement/CreateEmployee`, {
    method: "POST",

    headers: headers(token),

    body: JSON.stringify(employee),
  });

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};

/**
 * Update employee
 */
export const updateEmployee = async (employee, token) => {
  const response = await fetch(`${API}/EmployeeManagement/UpdateEmployee`, {
    method: "PUT",

    headers: headers(token),

    body: JSON.stringify(employee),
  });

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};

/**
 * Delete employee
 */
/**
 * Delete employee
 */
export const deleteEmployee = async (noEmploye, token) => {
  const response = await fetch(
    `${API}/EmployeeManagement/DeleteEmployee/${noEmploye}`,
    {
      method: "DELETE",
      headers: headers(token),
    },
  );

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};
const employeeService = {
  getEmployees,

  getEmployeeById,

  createEmployee,

  updateEmployee,

  deleteEmployee,
};

export default employeeService;
